import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch } from '../../../app/hooks';
import { number } from 'yup';
import { getAccountPaidThroughAsync, getAccountPaidThroughByIAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, deletePaidThroughAsyc } from './paidThroughSlice';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';

const itemClass = 'ms-1 ms-lg-0';
const PaidThroughItem = (props: any) => {
    const { paidThroughList, t, IsEdit, IsDelete } = props;
    const dispatch = useAppDispatch();

    const handleCheckboxChange = (e: any, rowId: any) => {

        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountPaidThroughId: number) => {
        dispatch(getAccountPaidThroughByIAsync(AccountPaidThroughId))
            .unwrap()
            .then((originalPromiseResult) => {
                //modelRef.current.click();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const onDeleteClick = (AccountPaidThroughId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deletePaidThroughAsyc(AccountPaidThroughId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Deleted Successfully", 'Success', "success", "toast-top-right");
                            dispatch(getAccountPaidThroughAsync());
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });

    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                        {IsDelete &&
                            <th className='w-25px'>
                                <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        checked={paidThroughList.every((item: any) => item.isSelected === 0) ? false :
                                            (paidThroughList.every((item: any) => item.isSelected === 1 ? true : false))
                                        }
                                        onChange={handleSelectAllChange}
                                    />
                                </div>
                            </th>
                        }
                        <th className='min-w-100%'>{t('Paid Through Name')}</th>
                        <th className='min-w-100%'>{t('Paid Through Code')}</th>
                        <th className='min-w-100%'>{t('Description')}</th>
                        <th className='min-w-100% text-end '></th>
                    </tr>
                </thead>
                <tbody>
                    {paidThroughList.length === 0 && <tr><td colSpan={5}><p className='noDataFound'>{t('No Record Found')}</p></td></tr>}
                    {paidThroughList.length > 0 && paidThroughList.map((paidThroughDetail: any, i: any) => (
                        <tr key={i}>
                            {IsDelete &&
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >

                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={paidThroughDetail.isSelected == 0 ? false : true}
                                            onChange={(e) => { handleCheckboxChange(e, paidThroughDetail.AccountPaidThroughId) }}
                                        />
                                    </div>
                                </td>
                            }
                            <td id={`${IsEdit ? 'kt_OffCanvas' : ''}`} className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(paidThroughDetail.AccountPaidThroughId) : undefined}>
                                <span className="d-block">
                                    {paidThroughDetail.PaidThroughAccountName}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {paidThroughDetail.PaidThroughAccountCode}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {paidThroughDetail.Description}
                                </span>

                            </td>
                            
                            <td className='text-center' >
                                <div className={clsx('app-navbar-item', itemClass)}>
                                    <Dropdown
                                        style={{ marginLeft: 1 }}
                                        className={clsx('cursor-pointer symbol')}
                                        data-kt-menu-attach='parent'
                                        data-kt-menu-placement='bottom-end'
                                    >
                                        <Dropdown.Toggle
                                            variant="transparent"
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content={"More"}
                                            data-tooltip-place="bottom"
                                        >
                                            <i className="bi bi-three-dots fs-7 " ></i>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-7 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            id="kt_OffCanvas"
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => onEditClick(paidThroughDetail.AccountPaidThroughId)}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil fs-6  iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">{`${t('Edit')}`}</span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            {IsDelete && IsEdit &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(paidThroughDetail.AccountPaidThroughId) }}
                                                        >
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >{`${t('Delete')}`}</span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )

}

export default PaidThroughItem